const Vue = require('vue');

class Pagination {
  constructor(options) {
    this.options = Object.assign({
      page: 1,
      perPage: 30,
      total: 0
    }, options);
    this.bus = new Vue();
  }

  pageIndex(index) {
    return (this.page - 1) * this.perPage + index + 1;
  }

  update(response) {  
    console.log('response headers', response.headers, response.headers['total']);
    this.options.total = parseInt(response.headers['total']);    
    this.bus.$emit('update');
  }

  get params() {
    return {
      page: this.options.page - 1,
      per_page: this.options.perPage
    };
  }

  get page() {
    return this.options.page;
  }

  set page(page) {
    this.options.page = page;
  }

  get perPage() {
    return this.options.perPage;
  }

  get total() {
    return this.options.total;
  }
}

module.exports = Pagination;


// WEBPACK FOOTER //
// ./src/pages/pagination.js